<div class="card shadow-sm border-0">
    <div class="card-header bg-white border-0 d-flex align-items-center justify-content-between pb-0">
        <div>
            <h4 class="m-0">
                {{ 'hub.console.organizations.connect-x-to-the-magaya-network' | translate : { value: organization.name } }}
            </h4>
        </div>
        <img alt="{{ 'hub.console.organizations.magaya-logo' | translate }}" src="https://cdn.qwyk.io/portals/assets/providers/catapult-qms.png" width="130">
    </div>

    <div class="card-body">
        <div style="max-width: 480px;">
            <p>{{ 'hub.console.organizations.enter-the-magaya-network-id' | translate }}</p>
            <form (reset)="onReset()" (submit)="onSubmit()" [formGroup]="form">
                <h5>{{ 'hub.console.organizations.magaya-network' | translate }}</h5>
                <div class="form-group p-fluid">
                    <label for="network_id">{{ 'hub.console.organizations.network-id' | translate }}</label>
                    <p-inputNumber
                        [max]="99999"
                        [min]="10000"
                        [useGrouping]="false"
                        formControlName="network_id"
                        id="network_id"
                        placeholder="{{ 'hub.console.organizations.magaya-network-id' | translate }}"
                    ></p-inputNumber>
                    <arv-validation-messages for="network_id"></arv-validation-messages>
                </div>

                <h5>{{ 'hub.console.organizations.livetrack-superuser' | translate }}</h5>

                <div class="form-group p-fluid">
                    <label for="superuser_username">{{ 'portal.registration.page1.label-username' | translate }}</label>
                    <input
                        formControlName="superuser_username"
                        id="superuser_username"
                        pInputText
                        placeholder="{{ 'hub.console.organizations.livetrack-username-of-the-superuser' | translate }}"
                        type="text">
                    <arv-validation-messages for="superuser_username"></arv-validation-messages>
                </div>

                <div class="form-group p-fluid">
                    <label for="superuser_password">{{ 'common.password' | translate }}</label>
                    <input
                        formControlName="superuser_password"
                        id="superuser_password"
                        pInputText
                        placeholder="{{ 'hub.console.organizations.livetrack-username-of-the-superuser' | translate }}"
                        type="text">
                    <arv-validation-messages for="superuser_password"></arv-validation-messages>
                </div>

                <div class="form-group">
                    <button
                        [disabled]="form.disabled"
                        class="btn btn-primary"
                        type="submit"
                    >
                        <fa-icon [icon]="['far', loading ? 'spinner' : 'link']" [animation]="$any(iconAnimation)"
                                 class="mr-1"></fa-icon>
                        {{ (loading ? 'hub.console.organizations.connecting' : 'hub.console.organizations.connect') | translate }} {{ organization.name }}
                    </button>
                </div>
            </form>

            <div *ngIf="error" class="alert alert-danger mt-3" role="alert">
                <b>{{ 'common.we-are-sorry' | translate }}...</b>
                <div>{{ 'common.try_again' | translate }}</div>
                <div *ngIf="(error.status === 400 || error.status === 503) && error.error?.message && error.error?.magaya_network_error">
                    <hr>
                    {{ error.error?.message }}
                    {{ error.error?.magaya_network_error }}
                </div>
                <div *ngIf="error.status === 422 && error.error?.errors">
                    <hr>
                    {{ error.error?.message}}
                    <ul *ngFor="let opt of error.error?.errors | objectToKVP" class="m-0">
                        <li *ngFor="let err of opt.value">{{ err }}</li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</div>

